import axios from 'axios';
import React, { useEffect, useState } from 'react';

interface IPost {
    id: number;
    title: string;
}

const GetData: React.FC = () => {

    const init: IPost[] = [];
    const [ posts, setPosts ] = useState(init);

    useEffect(() => {
        axios.get('https://jsonplaceholder.typicode.com/posts')
            .then(response => {
                setPosts(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    return (
        <>
        <h1>Test</h1>
        <ul>
            {posts.map((post: IPost) => (
                <li key={post.id}>{post.id} : {post.title}</li>
            ))}
        </ul>
        </>
    );
}

export default GetData;
